const TARIFF_BUNDLE_MONTHLY = {
  title: "AMZScout Bundle",
  period: "Period Monthly",
  offer: {
    name: "MONTHLY",
    price: 59,
    cents: 99,
  },
  tariff: {
    base: {
      pay: {
        price: 59,
        cents: 99,
        period: "Period Monthly",
      },
      buyNowPath: "/checkout/?bundle=bundle-ai-monthly",
    },
    PL: {
      pay: {
        discount: {
          price: 118,
          cents: 99,
        },
        price: 79,
        cents: 98,
        period: "Period Monthly",
      },
      save: 30,
      buyNowPath: "/checkout/?bundle=bundle-ai-pl-monthly",
    },
    R: {
      pay: {
        discount: {
          price: 118,
          cents: 99,
        },
        price: 79,
        cents: 98,
        period: "Period Monthly",
      },
      save: 30,
      buyNowPath: "/checkout/?bundle=bundle-ai-oa-monthly",
    },
    PL_R: {
      pay: {
        discount: {
          price: 177,
          cents: 99,
        },
        price: 99,
        cents: 97,
        period: "Period Monthly",
      },
      save: 70,
      buyNowPath: "/checkout/?bundle=bundle-ai-pl-oa-monthly",
    },
  },
};

export default TARIFF_BUNDLE_MONTHLY;
